<template>
  <div class="home">
    <p>{{ $store.state.customerName }} プロジェクト作成</p>
    <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    <div v-for="link in links" :key="link.text" class="selectbox">
      <v-btn @click="move(link.to)" height="100" width="250">{{
        link.text
      }}</v-btn>
    </div>
    <hr />
  </div>
</template>

<script>
// 画面デザインや色などはCSSで調整
export default {
  name: "index",
  components: {},
  data: () => ({
    links: [
      { to: "/report_builder", text: "パーツ一覧" },
      { to: "/router", text: "ルーティング作成" },
      { to: "/setting", text: "プロジェクト設定" },
    ],
  }),
  async mounted() {
    this.$store.state.customerID = Number(this.$route.params.id);
  },
  methods: {
    move(link) {
      this.$router.push({
        path: "/customer/" + this.$store.state.customerID + link,
      });
    },
    back() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>
<style>
.selectbox {
  float: left;
  margin: 4px;
}
</style>
